
import React from 'react';
import {
	Layer,
	Map as MapBox,
	NavigationControl,
	Source
} from 'react-map-gl';
import { MAPBOX_CORE } from 'vio-constants';
import { getAccessToken, getAuth0VaporCookie } from 'vio-libs';

import { IMapFeatureSources } from '../../interfaces';

import Fibers from './Fibers';

interface IMapProps extends IMapFeatureSources {
	previewFiber: any;
}

export const Map: React.FC<IMapProps> = ({
	sources = [],
	hiddenSources = [],
	previewFiber
}) => {
	// Vapor Cookie containing auth jwt
	const auth0Authentication = getAuth0VaporCookie();
	const mapRef = React.useRef();
	const initialViewState = {
		bounds: MAPBOX_CORE.DEFAULT_OPTIONS.COMPONENT.FIT_BOUNDS
	};

	const renderPreviewFiber = () => {
		return (
			<>
				<div id='preview-status'>Preview is Active</div>
				<Source id='preview-fiber' type='geojson' data={ previewFiber }>
					<Layer
						type='line'
						id='layer_preview'
						paint={ { 'line-color': '#716ACA' } } />
				</Source>
			</>
		);
	};

	return (
		<div className='mapbox'>
			<MapBox
				id='mapbox'
				dragRotate={ false }
				mapboxAccessToken={ getAccessToken() }
				maxBounds={ MAPBOX_CORE.DEFAULT_OPTIONS.COMPONENT.MAX_BOUNDS }
				minZoom={ MAPBOX_CORE.DEFAULT_OPTIONS.COMPONENT.MIN_ZOOM }
				maxZoom={ MAPBOX_CORE.DEFAULT_OPTIONS.ZOOM_LEVEL_ON_CLICK }
				renderWorldCopies={ MAPBOX_CORE.DEFAULT_OPTIONS.RENDER_WORLD_COPIES }
				initialViewState={ initialViewState }
				mapStyle={ MAPBOX_CORE.STYLES.DARK.URL }
				ref={ mapRef }
				transformRequest={ (url, resourceType) => {
					if ((resourceType === 'Source' || resourceType === 'Tile') && url.startsWith('https://tileserver')) {
						return {
							headers: { Authorization: `Bearer ${auth0Authentication?.idToken}` },
							url
						};
					}
				} }>
				<Fibers sources={ sources } hiddenSources={ hiddenSources } />

				{ previewFiber && renderPreviewFiber() }

				<NavigationControl
					position='bottom-left'
					showCompass={ false }
					style={ MAPBOX_CORE.ZOOM_CONTROLLER_STYLE } />
			</MapBox>
		</div>
	);
};

export default Map;
